import MuiMenuItem from '@material-ui/core/MenuItem';

export default MuiMenuItem;
